export default __webpack_public_path__ + "static/media/WhatsAppIcon.be595b41.svg";